import React, { useState } from "react";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import { emailLogin, passwordReset } from "../api";
import { UserAuth } from "../modules/account";
import ReactLoading from "react-loading";
import ReactModal from "../componets/ReactModal";

function Login() {
  const dispatch = useDispatch();
  const [modalIsOpen, setIsOpen] = useState(false);
  const [pwdModalIsOpen, setPwdModalIsOpen] = useState(false);
  const [searchPwd, setSearchPwd] = useState("");
  const [emailInfo, setEmailInfo] = useState({
    email: "",
    password: "",
  });
  const { status } = useSelector(({ account }) => {
    const { status } = account;
    return {
      status,
    };
  }, shallowEqual);
  // const onLogin = () => {
  //   googleLogin()
  //   .then(()=>{
  //     dispatch(UserAuth())
  //   })
  // }
  const onEmailLogin = () => {
    emailLogin(emailInfo)
      .then(() => {
        closeModal();
        dispatch(UserAuth());
      })
      .catch(() => {
        alert("아이디 또는 비밀번호가 일치하지 않습니다.");
      });
  };
  const handleData = (e) => {
    setEmailInfo({
      ...emailInfo,
      [e.target.name]: e.target.value,
    });
  };
  const closeModal = () => {
    setIsOpen(false);
  };
  const closePwdModal = () => {
    setSearchPwd("");
    setPwdModalIsOpen(false);
  };
  return (
    <dl>
      <dt>
        <img src={require("../images/avator.png")} alt="avator" />
      </dt>
      <dd>
        <ul>
          <li style={{ fontSize: 16, margin: "10px 0" }}>
            로그인이 필요합니다
          </li>
          <li>
            {/* <img onClick={onLogin} src={require('../images/google_login.png')} alt="google_login"/> */}
            <img
              onClick={() => setIsOpen(true)}
              src={require("../images/login-btn.png")}
              alt="apple_login"
            />
          </li>
        </ul>
      </dd>
      {status === "PENDING" && (
        <div className="loading">
          <ReactLoading type={"spokes"} color={"#ddd"} />
        </div>
      )}
      {modalIsOpen && (
        <ReactModal
          visible={modalIsOpen}
          title={
            <div className="memberTitle">
              <i className="material-icons">people</i> ID/PW로 로그인
            </div>
          }
          maskClosable={true}
          onClose={closeModal}
        >
          <div className="modalContent">
            <div className="smallLogo">
              <img src={require("../images/small-logo.png")} alt="small-logo" />
            </div>
            <div className="row">
              <div className="subTitle">
                <i className="material-icons">mail_outline</i> 이메일 주소
              </div>
              <div>
                <input
                  name="email"
                  type="text"
                  onChange={handleData}
                  placeholder="회원이메일을 입력해 주세요."
                  className="inputBox"
                />
              </div>
            </div>
            <div className="row">
              <div className="subTitle">
                <i className="material-icons">lock_outline</i> 비밀번호
              </div>
              <div>
                <input
                  className="inputBox"
                  type="password"
                  name="password"
                  placeholder="비밀번호를 입력해 주세요."
                  onChange={handleData}
                  onKeyPress={(e) => {
                    if (e.which === 13) {
                      onEmailLogin();
                    }
                  }}
                />
              </div>
            </div>
            <div className="passwordText">
              비밀번호를 잊으셨나요?{" "}
              <a
                href={() => false}
                onClick={() => {
                  closeModal();
                  setPwdModalIsOpen(true);
                }}
                className="passwrodSearchBtn"
              >
                비밀번호 찾기
              </a>
            </div>
          </div>
          <div className="memberBtn">
            <a href={() => false} onClick={onEmailLogin}>
              <img src={require("../images/login-btn2.png")} alt="login-btn2" />
            </a>
          </div>
        </ReactModal>
      )}
      {pwdModalIsOpen && (
        <ReactModal
          visible={pwdModalIsOpen}
          title={
            <div className="memberTitle">
              <i className="material-icons">lock</i> 비밀번호 찾기
            </div>
          }
          maskClosable={true}
          onClose={closePwdModal}
        >
          <div className="modalContent">
            <div className="emailRow">
              가입하신 이메일을 입력하시면 비밀번호 재설정
              <br /> 이메일이 발송됩니다.
            </div>
            <div className="row">
              <div className="subTitle">
                <i className="material-icons">mail_outline</i> 이메일 주소
              </div>
              <div>
                <input
                  type="text"
                  onChange={(e) => {
                    setSearchPwd(e.target.value);
                  }}
                  placeholder="회원이메일을 입력해 주세요."
                  className="inputBox"
                />
              </div>
            </div>
          </div>
          <div class="memberBtn">
            <a
              href={() => false}
              onClick={() => {
                passwordReset(searchPwd)
                  .then((res) => {
                    alert("이메일 발송완료");
                    setSearchPwd("");
                    setPwdModalIsOpen(false);
                  })
                  .catch((err) => {
                    alert("해당 이메일이 존재하지 않습니다");
                  });
              }}
            >
              <img src={require("../images/email-btn.png")} alt="email-btn" />
            </a>
          </div>
        </ReactModal>
      )}
    </dl>
  );
}

export default Login;
